import { styled } from '@mui/material';
import { css } from '@emotion/react';
import { marginRight } from 'utils';
import { paddingRight } from 'utils/styles';

export const StyledLayoutHeader = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    min-height: 68px;
    max-height: 68px;
    background: #ffffff;
    box-shadow: 0px 3px 50px -1px rgba(50, 50, 71, 0.05);
    padding: 8px 32px;
    margin: 0;
    z-index: 4;
    width: 100%;
    box-sizing: border-box;
    gap: 0;
    position: sticky !important;
    top: 0;

    .header-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
      width: 100%;
      min-height: 52px;
    }

    &.has-search-row {
      max-height: none;
      min-height: unset;
      gap: 16px;
      padding: 8px 32px 16px;
      box-shadow: none;
      border-bottom: 1px solid #e4e9ec;

      .header-divider {
        width: 100%;
        height: 1px;
        background: #f5f5f5;
        flex-shrink: 0;
      }

      .header-search-row {
        display: flex;
        align-items: start;
        gap: 12px;
        width: 100%;
        min-width: 0;

        .query-filter {
          margin-left: 0;
        }
      }

      .header-filter {
        .padding {
          padding: 0;
        }
      }
    }

    .app-logo {
      width: 80px;
    }

    .left-section {
      background-color: #fff;
      z-index: 2;

      .header-filter {
        position: relative;
      }

      .header-actions {
        .avatar {
          width: 44px;
          height: 44px;
          background: #eeeef2;
          border: 1px solid #e2e2ea;
          ${marginRight('28px')}
          border-radius: 50%;
          cursor: pointer;
          object-fit: cover;
          z-index: 2;
        }
      }

      .query-filter-selectbox {
        overflow: hidden;
        width: 100%;

        span {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .subject-icon {
          ${paddingRight('4px')}
          flex-shrink: 0;
        }
        .arrow-icon {
          display: block;
          flex-shrink: 0;
          transition: transform 0.2s ease;

          &.is-open {
            transform: rotate(180deg);
          }
        }
      }
    }

    .right-section {
      overflow: hidden;
      flex-grow: 1;

      &.isMobile {
        cursor: pointer;
      }
    }

    .seperator {
      margin: 0 26px;
    }
    .title {
      font-style: normal;
      font-size: 1.5rem;
      color: #222222;
      font-weight: 800;
      line-height: 36px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .header-filter-wrapper {
      width: 100%;
    }

    @media (max-width: 1300px) {
      padding: 0 32px;

      .left-section {
        .header-filter {
          .query-filter {
            width: auto;

            .query-filter__select {
              width: 191px;
            }
          }
          .range-picker {
            width: 158px;
            min-width: unset;

            .date-time {
              flex: 1;

              > div {
                width: 100%;
              }
            }
            .custom-range-input {
              width: 100%;
              flex: 1;
            }
          }
          .jalali-date-picker {
            .date-time {
              flex: 1;

              > div {
                width: 100%;
              }

              .custom-range-input {
                width: 100%;
                flex: 1;
              }
            }
          }
        }
      }
    }

    @media (max-width: 1094px) {
      .seperator {
        display: none;
      }

      .header-actions {
        .user-profile {
          .avatar {
            ${marginRight('16px')}
          }
        }
      }

      .left-section {
        .support-menu,
        .socket-menu {
          display: none;
        }
      }
    }

    @media (max-width: 960px) {
      padding: ${theme.direction === 'rtl' ? '0 50px 0 16px' : '0 16px 0 50px'};

      .title {
        font-size: 1rem;
      }

      /* Only pages with a search row need the title clear of the menu button */
      &.has-search-row {
        .title {
          ${marginRight('20px')}
        }
      }
    }

    @media (max-width: 600px) {
      transition: all 0.1s ease;

      .app-logo {
        width: 80px;
      }

      .left-section {
        .header-filter {
          transition: all 0.1s ease;
          box-sizing: border-box;
          position: absolute;
          right: 0;
          left: 0;
          width: 100%;
          top: 62px;
          background: #fff;
          padding: 0 16px 8px 16px;
          margin: 0;
          box-shadow: 0px 10px 30px -1px rgba(50, 50, 71, 0.03);

          .query-filter {
            width: 45%;
            flex: 1;

            .query-filter__select {
              width: 100%;
            }

            .MuiSelect-root {
              color: #333333;
            }
          }
          .range-picker {
            width: 45%;
            flex: 1;
          }
          .jalali-date-picker {
            width: 45%;
            flex: 1;
          }
        }
      }

      &.collapsed {
        .left-section {
          .header-filter {
            position: unset;
            right: unset;
            left: unset;
            width: unset;
            top: unset;
            box-shadow: unset;
            padding: 0;

            /**
             * حالت جمع‌شده: فقط آیکون نوع انتخاب (جست‌وجو / موضوع / فراموضوعی)
             * به‌همراه فلش، بدون متن
             */
            .query-filter {
              width: auto;

              .query-filter__select {
                width: auto;
                flex-shrink: 0;
              }

              .query-filter-selectbox {
                gap: 8px;
                justify-content: center;

                .query-filter-selectbox__value {
                  flex: 0 0 auto;
                  overflow: visible;

                  span {
                    display: none;
                  }
                }

                .query-filter-selectbox__mode-icon {
                  font-size: 1.25rem;

                  &.is-subject-mode {
                    display: block;
                  }
                }

                .arrow-icon {
                  display: block;
                }
              }
            }

            .range-picker,
            .jalali-date-picker {
              max-width: 46px;
              padding: 0 !important;
              .custom-range-input {
                display: none;
              }

              .date-time {
                .icon {
                  padding: 12px !important;
                }
                .date-time-wrapper {
                  justify-content: center !important;
                }
              }
            }

            .jalali-date-picker {
              min-width: unset;
            }
            .MuiSelect-select {
              padding: 0 12px !important;
            }
          }
        }
      }

      .padding {
        padding: 8px 16px 10px;
      }

      /**
       * چیدمان موبایلِ صفحاتی که ردیف جست‌وجو دارند:
       * سطر اول موضوع و تقویم با عرض برابر، سطر دوم اینپوت جست‌وجو،
       * سطر سوم دکمه‌ها چسبیده به انتهای سطر
       */
      &.has-search-row {
        gap: 16px;
        padding: 8px 16px 8px 16px;

        /* بعد از اسکرول، ردیف جست‌وجو رندر نمی‌شود و نوار به حالت جمع برمی‌گردد */
        &.collapsed {
          gap: 0;
        }

        .title {
          ${marginRight('32px')}
        }

        .header-divider {
          display: none;
        }

        .header-search-row {
          flex-direction: column;
          align-items: stretch;
          gap: 12px;
          align-items: start;
        }

        .header-search-row .header-filter {
          position: static;
          width: 100%;
          padding: 0;
          margin: 0;
          background: none;
          box-shadow: none;

          .header-filter-wrapper {
            gap: 12px;
            width: 100%;
          }

          .query-filter {
            flex: 1 1 0;
            min-width: 0;
            margin-left: 0;

            .query-filter__select {
              width: 100%;
              flex-shrink: 1;
            }
          }

          .range-picker,
          .jalali-date-picker {
            flex: 1 1 0;
            min-width: 0;
            width: auto;
          }
        }
      }
    }
  `
);
